import React__default from 'react';
import { Avatar } from '@deal/components';
import { ConsumerRichCardEvents } from '../../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../../containers/RichCardEventEmitter/index.js';
import styles from './styles.css.js';
import { ExpertJoinedConsumerMessageComponent } from './ExpertJoinedConsumerMessage.generated.js';

var ExpertJoinedConsumerMessage = function ExpertJoinedConsumerMessage(_a) {
  var richCard = _a.richCard;
  var richCardEventEmitter = useRichCardEventEmitter();
  var expertId = richCard.expertId;
  return React__default.createElement(ExpertJoinedConsumerMessageComponent, {
    variables: {
      vanityIdOrId: expertId
    }
  }, function (_a) {
    var data = _a.data;

    if (data && data.findExpert) {
      var _b = data.findExpert,
          shortName = _b.shortName,
          department = _b.department,
          expertProfile = _b.expertProfile,
          expertAttributes = _b.expertAttributes,
          vanityId_1 = _b.vanityId;
      var isPlaceholderExpert = expertAttributes && expertAttributes.placeholderExpert;
      var category = department.topLevelCategory;
      return React__default.createElement("div", {
        className: styles.container
      }, expertProfile && expertProfile.profilePhoto && React__default.createElement("div", {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_EXPERT_PROFILE,
            vanityIdOrId: vanityId_1 || expertId
          });
        }
      }, React__default.createElement(Avatar, {
        size: 64,
        name: shortName,
        src: expertProfile.profilePhoto.url
      })), React__default.createElement("div", {
        className: styles.message
      }, isPlaceholderExpert ? React__default.createElement("span", {
        className: styles.name
      }, shortName) : React__default.createElement("span", {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_EXPERT_PROFILE,
            vanityIdOrId: vanityId_1 || expertId
          });
        },
        className: styles.name
      }, shortName), ' ', "joined the conversation"), !isPlaceholderExpert && React__default.createElement("div", {
        className: styles.category
      }, category.singularDisplayName, " expert"));
    } else {
      return null;
    }
  });
};

export default ExpertJoinedConsumerMessage;
//# sourceMappingURL=index.js.map
